<template>
    <main class="page__content">
        <div class="plain-content">
            <div class="plain-content__inner">
                <div class="plain-content__header">
                    <h1>Datenschutzerklärung</h1>
                </div>
                <div class="plain-content__body">
                    <p>
                        Stadtwerke Velbert GmbH, Kettwiger Str. 2 in 42549 Velbert
                        <br>
                        <br>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. So behandeln wir
                        Ihre personenbezogenen Daten selbstverständlich stets entsprechend der
                        gesetzlichen Datenschutzvorschriften. Wir haben einen fachkundigen und
                        zuverlässigen externen Datenschutzbeauftragten bestellt. Die externe
                        Datenschutzbeauftragung wird von der Gesellschaft für Compliance und
                        Datenschutz mbH wahrgenommen.
                    </p>
                    <p>
                        Nachfolgend möchten wir Sie über die Verarbeitung von personenbezogenen
                        Daten informieren.
                    </p>
                    <h2 class="h5">Erhebung und Verarbeitung persönlicher Daten</h2>
                    <p>
                        Sie können unser Online-Angebot grundsätzlich ohne Offenlegung Ihrer
                        Identität nutzen. Sollten wir auf der Internetpräsenz z. B. im Rahmen von
                        Kontaktformularen oder bei der Anmeldung/Registrierung personenbezogene
                        Daten abfragen (wie beispielsweise Name, Anschrift oder E-Mail-Adresse),
                        erfolgt dies auf freiwilliger Basis. Diese Informationen nutzen wir zu
                        eigenen geschäftlichen Zwecken (wie dem Versand der angeforderten
                        Materialen/Informationen).
                        <br>
                        <br>Bei Fragen jeglicher Art bieten wir Ihnen die Möglichkeit, mit uns per
                        E-Mail Kontakt aufzunehmen. Die Datenverarbeitung zum Zwecke der
                        Kontaktaufnahme mit uns erfolgt nach Art. 6 Abs. 1 S. 1 lit. a DSGVO auf
                        Grundlage Ihrer freiwillig erteilten Einwilligung.
                        <br>
                        <br>Die für die Benutzung des Kontaktformulars von uns erhobenen
                        personenbezogenen Daten werden nach Erledigung der von Ihnen gestellten
                        Anfrage sowie nach Ablauf der steuerlichen und handelsrechtlichen
                        Aufbewahrungspflichten gelöscht.
                        <br>
                        <br>Eine einmal erteilte Einwilligung – zum Beispiel zum Zwecke der Zusendung
                        eines Newsletters oder anderer interessanter Informationen aus unserem
                        Hause – können Sie jederzeit ohne Angabe von Gründen mit Wirkung für die
                        Zukunft bei uns widerrufen. Hierzu können Sie uns per E-Mail oder über
                        einen anderen innerhalb des Newsletters genannten Weg erreichen.
                    </p>
                    <h2 class="h5">Cookies</h2>
                    <p>
                        Diese Seite verwendet „Cookies“. Cookies sind Textdateien, die auf Ihrem
                        Computer gespeichert werden und die eine Analyse der Benutzung der
                        Internetpräsenz ermöglichen und Sie bei Ihrem nächsten Besuch automatisch
                        wieder erkennen. Sie können die Installation der Cookies durch eine
                        entsprechende Einstellung Ihres Browsers verhindern. Dies kann ggf. dazu
                        führen, dass Sie nicht alle Angebote vollumfänglich nutzen können.
                    </p>
                    <h2 class="h5">Protokollierung</h2>
                    <p>
                        Bei jedem Zugriff auf die Internetpräsenz werden Protokolle zu
                        statistischen Zwecken erstellt und verarbeitet, wobei der einzelne Benutzer
                        hierbei anonym bleibt:
                    </p>
                    <ul>
                        <li>
                            Referrer (Seite, von deren Link Sie zu dieser Internetpräsenz gelangt
                            sind)
                        </li>
                        <li>Suchbegriffe (bei Suchmaschinen als Referrer)</li>
                        <li>IP wird zur Bestimmung des Herkunftslands und des Providers ausgewertet</li>
                        <li>Browser, Betriebssystem, installierte Plug-ins und Bildschirmauflösung</li>
                        <li>Aufenthaltszeit auf den Seiten</li>
                    </ul>
                    <p>
                        Die genannten Daten werden auf Basis unseres berechtigten Interesses gemäß
                        Art. 6 Abs. 1 S.1 lit. f DSGVO durch uns zu folgenden Zwecken verarbeitet:
                    </p>
                    <ul>
                        <li>
                            Gewährleistung eines reibungslosen Verbindungsaufbaus der
                            Internetpräsenz,
                        </li>
                        <li>Gewährleistung einer komfortablen Nutzung unserer Internetpräsenz,</li>
                        <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
                        <li>zu weiteren administrativen Zwecken.</li>
                    </ul>
                    <p>
                        Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns konkrete
                        Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden. Die Daten
                        werden umgehend gelöscht, wenn sie zur Zweckerreichung nicht mehr
                        erforderlich sind, spätestens jedoch nach sechs Monaten.
                    </p>
                    <h2 class="h5">Weitergabe der Daten</h2>
                    <p>
                        Eine Weitergabe an Dritte, zu kommerziellen oder nicht-kommerziellen
                        Zwecken, findet ohne Ihre ausdrückliche Zustimmung grundsätzlich nicht
                        statt. Wir geben Ihre persönlichen Daten nur dann an Dritte weiter, wenn
                        dies gesetzlich zulässig [wie z. B. auf Basis des Artikel 6 DSGVO] und/oder
                        erforderlich ist. Teilweise setzen wir Dienstleister für die gesetzlich
                        vorgesehene Auftragsverarbeitung von Daten ein; so wird die Internetseite
                        bei der Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, gehostet
                        und von Ortmann und Kollegen, Seyengasse 5, 50678 Köln, gepflegt. Die volle
                        Verantwortung für die Datenverarbeitung verbleibt hierbei bei uns. Des
                        Weiteren nutzen wir zum Teil Plugins weiterer Anbieter auf unserer
                        Internetpräsenz; näheres finden Sie weiter unten.
                    </p>
                    <h2 class="h5">Haftung für eigene Inhalte</h2>
                    <p>
                        Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die
                        Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch
                        keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte
                        auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                    </p>
                    <h2 class="h5">Haftung für Links (Inhalte fremder Anbieter)</h2>
                    <p>
                        Von diesen eigenen Inhalten sind Querverweise ("Links") auf die von anderen
                        Anbietern bereitgehaltenen Inhalte zu unterscheiden. Auf deren Inhalt haben
                        wir keinen Einfluss; für die Inhalte der verlinkten Seiten ist stets der
                        jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                    </p>
                    <h2 class="h5">Rechte der Betroffenen</h2>
                    <p>
                        Wir informieren Sie hiermit darüber, dass Sie gemäß Artikel 15 ff. DSGVO
                        uns gegenüber unter den dort definierten Voraussetzungen das Recht auf
                        Auskunft über die betreffenden personenbezogenen Daten sowie auf
                        Berichtigung oder Löschung oder auf Einschränkung der Verarbeitung oder
                        eines Widerspruchsrechts gegen die Verarbeitung sowie des Rechts auf
                        Datenübertragbarkeit haben. Auch haben Sie gemäß Artikel 77 DSGVO das Recht
                        der Beschwerde bei einer Datenschutz-Aufsichtsbehörde, wenn Sie der Ansicht
                        sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten
                        gegen diese Verordnung verstößt. Wenn die Verarbeitung auf Artikel 6 Absatz
                        1 Buchstabe a DSGVO oder Artikel 9 Absatz 2 Buchstabe a DSGVO beruht
                        (Einwilligung), haben Sie ferner das Recht, die Einwilligung jederzeit zu
                        widerrufen, ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung bis
                        zum Widerruf erfolgten Verarbeitung berührt wird.
                    </p>
                    <h2 class="h5">Änderung unserer Datenschutzbestimmungen</h2>
                    <p>
                        Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen,
                        damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um
                        Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z. B.
                        bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die
                        neue Datenschutzerklärung.
                    </p>
                    <h2 class="h5">Fragen</h2>
                    <p>
                        Wenn Sie Fragen hinsichtlich der Verarbeitung Ihrer persönlichen Daten
                        haben, können Sie sich direkt an unseren Datenschutzbeauftragten wenden,
                        der mit seinem Team auch im Falle von Auskunftsersuchen, Anträgen oder
                        Beschwerden zur Verfügung steht.
                    </p>
                    <h2 class="h5">Kontakt zum Datenschutzbeauftragten</h2>
                    <p>
                        Patrick Rayermann (TÜV-zertifizierter Datenschutzbeauftragter)
                        <br>Gesellschaft für Compliance und Datenschutz mbH
                        <br>Hackenstr. 7, 80331 München
                        <br>E-Mail:
                        <a href="mailto:dsb-stwv@certitut.de">dsb-stwv@certitut.de</a>
                        <br>
                        <a href="http://www.certitut.de">www.certitut.de</a>
                    </p>
                    <h2 class="h5">GoogleMaps</h2>
                    <p>
                        Zur vereinfachten Anreise bieten wir Ihnen die Nutzung von Google Maps zur
                        Darstellung von Karten und zur Erstellung von Anfahrtsplänen. Google Maps
                        wird von Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043,
                        USA betrieben. Diese Seiten werden Ihnen entsprechend kenntlich gemacht.
                        Durch die Nutzung dieses Services erklären Sie sich mit der Erhebung,
                        Verarbeitung und Nutzung der dabei erhobenen sowie der von Ihnen
                        eingegebenen Daten durch Google einverstanden. Die Nutzungsbedingungen für
                        Google Maps finden Sie unter
                        <a
                            href="http://www.google.com/intl/de_de/help/terms_maps.html"
                        >http://www.google.com/intl/de_de/help/terms_maps.html</a>
                        .
                    </p>
                    <h2 class="h5">Webanalyse mit Google Analytics</h2>
                    <p>
                        Diese Website benutzt Google Analytics, einen Webanalysedienst der Google
                        Inc. („Google“). Google Analytics verwendet sog. „Cookies“, Textdateien,
                        die auf Ihrem Computer gespeichert werden und die eine Analyse der
                        Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten
                        Informationen über Ihre Benutzung dieser Website (einschließlich Ihrer
                        verkürzten IP-Adresse) wird an einen Server von Google in den USA
                        übertragen und dort gespeichert. Google wird diese Informationen benutzen,
                        um Ihre Nutzung der Website auszuwerten, um Reports über die
                        Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um
                        weitere mit der Websitenutzung und der Internetnutzung verbundene
                        Dienstleistungen zu erbringen. Auch wird Google diese Informationen
                        gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben
                        ist oder soweit Dritte diese Daten im Auftrag von Google verarbeiten.
                        Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten der Google in
                        Verbindung bringen.
                        <br>
                        <br>Sie können der Verwendung Ihrer Daten durch Google Analytics widersprechen,
                        indem Sie ein sog. Add-on in Ihrem Browser installieren. Hierzu können Sie
                        dem nachfolgenden Link folgen, der Sie auf die Seite von Google führt:
                        <a
                            href="http://tools.google.com/dlpage/gaoptout?hl=de"
                        >http://tools.google.com/dlpage/gaoptout?hl=de</a>
                        .
                    </p>
                    <h3>Datenschutzrechte</h3>
                    <h2 class="h5">Informationen zur Datenverarbeitung gemäß Artikel 13 und 14 DSGVO</h2>
                    <p>
                        Hiermit unterrichten wir Sie über die Verarbeitung Ihrer personenbezogenen
                        Daten:
                    </p>
                    <h2 class="h5">Datenverarbeitung</h2>
                    <p>
                        Wir – die Stadtwerke Velbert GmbH, Kettwiger Str. 2 in 42549 Velbert –
                        verarbeiten personenbezogene Daten im Hinblick auf Ihre Person im
                        Zusammenhang mit der Begründung, Durchführung und Abwicklung des
                        geschlossenen Vertrags und dessen Anbahnung auf Grundlage von Art. 6 Abs. 1
                        S. 1 lit. b DSGVO sowie zur Erfüllung von rechtlichen Verpflichtungen
                        (beispielsweise Handels- und Steuerrecht) auf Grundlage von Art. 6 Abs. 1
                        S. 1 lit. c DSGVO.
                        <br>
                        <br>Ferner werden Daten auch zu berechtigten Zwecken gemäß Art. 6 Abs. 1 S. 1
                        lit. f DSGVO verarbeitet, wie Vermarktung, interne Marktforschungs- und
                        Marketingzwecke, betriebsinterner Statistiken, Optimierung der Angebote.
                        Die berechtigten Interessen liegen insbesondere in der Optimierung von
                        Prozessen und der kostengerechten Zurechnung; hierbei werden Ihre
                        Interessen, Grundrechte und Grundfreiheiten gebührend berücksichtigt.
                        <br>
                        <br>Nur sofern Sie hierzu Ihre Einwilligung erteilt haben, nutzen wir Daten und
                        Fotos von Ihnen im Rahmen der Öffentlichkeitsarbeit (genauere Informationen
                        zum Zweck und den Datenumfang können Sie der jeweiligen
                        Einwilligungserklärung entnehmen).
                        <br>
                        <br>Sofern Sie uns hierzu Ihre Einwilligung erteilt haben, nutzen wir Ihre
                        Daten, um Ihnen Informationen über Produkte, Dienstleistungen,
                        Veranstaltungen und anderes Wissenswertes zu unserem Hause zuzusenden.
                        Dieser Zusendung können Sie jederzeit mit Wirkung für die Zukunft
                        widersprechen.
                    </p>
                    <h2 class="h5">Weitergabe / Dienstleister</h2>
                    <p>
                        Ihre personenbezogenen Daten werden teilweise an externe Dienstleister
                        (beispielsweise Steuerberater, Rechtsberater) weitergeben. Zum Teil können
                        externe IT-Dienstleister (im Rahmen einer Auftragsdatenverarbeitung gemäß
                        Artikel 28 DSGVO) auf Ihre Daten zugreifen. Hierbei agieren die
                        Dienstleister weisungsgebunden, was durch entsprechende Verträge
                        sichergestellt wurde.
                    </p>
                    <h2 class="h5">Aufbewahrung und Löschung der Daten</h2>
                    <p>
                        Ihre Daten werden solange aufbewahrt, wie dies für die jeweiligen o. g.
                        Zwecke erforderlich ist. Die Daten werden spätestens nach Ablauf der
                        gesetzlichen Aufbewahrungsfristen des Zivil-, Handels- und Steuerrechts
                        gelöscht.
                    </p>
                    <h2 class="h5">Ihre Rechte</h2>
                    <p>
                        Wir informieren Sie darüber, dass Sie gemäß Artikel 15 ff. DSGVO unter den
                        dort definierten Voraussetzungen folgende Rechte des Betroffenen haben:
                        Recht auf Auskunft über die betreffenden personenbezogenen Daten sowie auf
                        Berichtigung oder Löschung oder auf Einschränkung der Verarbeitung oder
                        Widerspruchsrecht gegen die Verarbeitung sowie Recht auf
                        Datenübertragbarkeit. Auch haben Sie gemäß Artikel 77 DSGVO das Recht der
                        Beschwerde bei einer Datenschutz-Aufsichtsbehörde. Wenn die Verarbeitung
                        auf Artikel 6 Absatz 1 Buchstabe a DSGVO oder Artikel 9 Absatz 2 Buchstabe
                        a DSGVO beruht (Einwilligung) haben Sie ferner das Recht, die Einwilligung
                        jederzeit zu widerrufen, ohne dass die Rechtmäßigkeit der aufgrund der
                        Einwilligung bis zum Widerruf erfolgten Verarbeitung berührt wird.
                    </p>
                    <h2 class="h5">Datenschutzbeauftragter</h2>
                    <p>
                        Der für die Stadtwerke Velbert GmbH zuständige Datenschutzbeauftragte ist
                        Patrick Rayermann (TÜV-zertifizierter Datenschutzbeauftragter),
                        Gesellschaft für Compliance und Datenschutz mbH
                        <br>Hackenstr. 7, 80331 München
                        <br>E-Mail:
                        <a href="mailto:%2520dsb-stwv@certitut.de">dsb-stwv(at)certitut.de</a>
                        <br>
                        <a href="http://www.certitut.de">www.certitut.de</a>
                    </p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'PageTermsOfParticipation'
}
</script>



// WEBPACK FOOTER //
// src/components/PageDataProtection.vue